export default __webpack_public_path__ + "navigation-examples-custom-server-v1-960-9d5018c6cc0bed661b827ec936d39df7.webp";